"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _cccisdLaravelResources = require("cccisd-laravel-resources");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Preview = function Preview(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'flex-end',
      marginBottom: '1em'
    }
  }, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
    trigger: /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn btn-primary"
    }, "Preview"),
    title: "Preview",
    size: "calc(100vw - 30px)"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelResources.ResourceCenter, {
    handle: "default",
    match: {
      isExact: true,
      params: {
        tab: undefined,
        id: undefined
      },
      path: '',
      url: ''
    },
    config: props.config
  })));
};
var _default = exports["default"] = Preview;